module.exports = {
    root: true,
    env: {
        node: true,
        browser: true,
    },
    extends: [
        'eslint:recommended',
        'plugin:vue/vue3-recommended',
    ],
    parserOptions: {
        ecmaVersion: 2020,
        sourceType: 'module',
    },
    globals: {
        defineOptions: 'readonly', // ✅ Allow Vue macro
    },
    rules: {
        // Optional: Customize rules
    },
}
